import { gql } from "@apollo/client";
import { REMITTANCE_ITEM_FRAGMENT } from "./remittanceItemFragment";
export const GET_REMITTANCE_ITEM_BY_ID = gql`
  ${REMITTANCE_ITEM_FRAGMENT}
  query RemittanceItemById($params: GetRemittanceItemByIdInput!) {
    remittanceItemById(params: $params) {
      ...RemittanceItemFields
    }
  }
`;
